import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const Privacy = () => {

    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const [about, setAbout] = useState([]);

     const getLocalizedField = (item, fieldBase) => {
      if (currentLanguage === "en")
        return item[`${fieldBase}En`] || item[fieldBase];
      if (currentLanguage === "ru")
        return item[`${fieldBase}Ru`] || item[fieldBase];
      return item[fieldBase];
    };

  useEffect(() => {
    getPrivacy();
  }, []);

  const getPrivacy = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/privacy.php`,
        { withCredentials: false }
      );
      setAbout(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  return (
    <div className="md:max-w-container max-w-containerSm mx-auto py-10 md:py-20">
      <div className="mx-auto text-gray-800">
         <p dangerouslySetInnerHTML={{ __html: getLocalizedField(about, "content") }} />
      </div>
    </div> 
  );
};

export default Privacy;
